import { css } from "@emotion/react";
import React, { forwardRef } from "react";

export type ListProps = React.ComponentPropsWithRef<"ul">;

/**
 * Listコンポーネントのデザインは今後大きく変更される可能性があります。
 *
 * 可能であればMenuコンポーネントを使用してください。
 */
export const List = forwardRef<HTMLUListElement, ListProps>(
  ({ children, ...props }, ref) => {
    return (
      <ul
        ref={ref}
        css={css`
          position: relative;
          padding: 0;
          margin: 0;
          list-style: none;
        `}
        {...props}
      >
        {children}
      </ul>
    );
  },
);
